import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { IconPaymentAmex, IconPaymentDinersclub, IconPaymentInvoice, IconPaymentMastercard, IconPaymentPayPal, IconPaymentSepa, IconPaymentSofort, IconPaymentVisa } from '@travel-frontend/icons';
import { PAYMENT_METHOD_AX, PAYMENT_METHOD_DINERS_CLUB, PAYMENT_METHOD_EC, PAYMENT_METHOD_INVOICE, PAYMENT_METHOD_PAYPAL, PAYMENT_METHOD_PAYPALLIGHT, PAYMENT_METHOD_SEPA, PAYMENT_METHOD_SOFORT, PAYMENT_METHOD_VISA } from '../../../../../components/TravelDetailsOverlay/models.js';
const paymentIconByMethod = {
  [PAYMENT_METHOD_VISA]: _jsx(IconPaymentVisa, {}),
  [PAYMENT_METHOD_EC]: _jsx(IconPaymentMastercard, {}),
  [PAYMENT_METHOD_AX]: _jsx(IconPaymentAmex, {}),
  [PAYMENT_METHOD_INVOICE]: _jsx(IconPaymentInvoice, {}),
  [PAYMENT_METHOD_SEPA]: _jsx(IconPaymentSepa, {}),
  [PAYMENT_METHOD_DINERS_CLUB]: _jsx(IconPaymentDinersclub, {}),
  [PAYMENT_METHOD_SOFORT]: _jsx(IconPaymentSofort, {}),
  [PAYMENT_METHOD_PAYPAL]: _jsx(IconPaymentPayPal, {}),
  [PAYMENT_METHOD_PAYPALLIGHT]: _jsx(IconPaymentPayPal, {})
};
export const PaymentIcon = ({
  paymentMethod
}) => {
  return paymentIconByMethod[paymentMethod] ?? null;
};